import React from 'react'
import DifferenceCard from './DifferenceCard'

const StandardYearDTGCard = ({ component, source }) => (
    <DifferenceCard
        title={component.name}
        value={source.dtgMean}
        differences={[
            {
                title: 'Vergeleken met vorig jaar',
                prev: source.dtgMeanPrev,
                diff: source.dtgMeanPrevYearDiff,
                diffPct: source.dtgMeanPrevYearDiffPct,
                reverse: true
            }
        ]}
    />
)

export default StandardYearDTGCard